import { Accessor } from '@deck.gl/core';
import { _TextBackgroundLayer as TextBackgroundLayer } from '@deck.gl/layers';
import { globeHorizonClipModule } from '../../modules/hide-opposite-globe.js';
import hiddable from '../../modules/isHiddableModule.js';

export class HidableTextBackgroundLayer<TData, TExtraProps = object> extends TextBackgroundLayer<
    TData,
    TExtraProps & {
        getIsHidden: Accessor<TData, 0 | 1>;
    }
> {
    initializeState() {
        super.initializeState();
        this.getAttributeManager()!.addInstanced({
            isHidden: {
                size: 1,
                accessor: 'getIsHidden',
                defaultValue: 0.0
            }
        });
    }

    getShaders() {
        const shaders = super.getShaders();
        return {
            ...shaders,
            modules: [...shaders.modules, hiddable, globeHorizonClipModule]
        };
    }
}
